import { DmsAnalyticsInterface } from 'dms-analytics';

export type ContextValue = DmsAnalyticsInterface | null;

export const amplitudeTracker = async (
  amp: ContextValue,
  eventName: string,
  data?: Record<any, any>
): Promise<void> => {
  try {
    await amp?.track(eventName, data);
  } catch (err) {
    console.log(err);
  }
};
